import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const exercisetypesAdapter = createEntityAdapter({})

const initialState = exercisetypesAdapter.getInitialState()

export const exercisetypesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getExercisetypes: builder.query({
            query: () => ({
                url: 'exercises/types',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedexercisetypes = responseData.map(exercisetype => {
                    exercisetype.id = exercisetype._id
                    return exercisetype
                });
                return exercisetypesAdapter.setAll(initialState, loadedexercisetypes)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Exercisetype', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Exercisetype', id }))
                    ]
                } else return [{ type: 'Exercisetype', id: 'LIST' }]
            }
        }),
        addNewExercisetype: builder.mutation({
            query: initialUserData => ({
                url: 'exercises/types',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'Exercisetype', id: "LIST" }
            ]
        }),
        updateExercisetype: builder.mutation({
            query: initialUserData => ({
                url: 'exercises/types',
                method: 'PATCH',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Exercisetype', id: arg.id }
            ]
        }),
        deleteExercisetype: builder.mutation({
            query: ({ id }) => ({
                url: `exercises/types`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Exercisetype', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetExercisetypesQuery,
    useAddNewExercisetypeMutation,
    useUpdateExercisetypeMutation,
    useDeleteExercisetypeMutation,
} = exercisetypesApiSlice

// returns the query result object
export const selectexercisetypesResult = exercisetypesApiSlice.endpoints.getExercisetypes.select()

// creates memoized selector
const selectexercisetypesData = createSelector(
    selectexercisetypesResult,
    exercisetypesResult => exercisetypesResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllexercisetypes,
    selectById: selectExercisetypeById,
    selectIds: selectExercisetypeIds
    // Pass in a selector that returns the exercisetypes slice of state
} = exercisetypesAdapter.getSelectors(state => selectexercisetypesData(state) ?? initialState)